module.exports = __webpack_public_path__ + "static/media/Scape_Kit.15f136f2.zip";